import forgotpassword from "../pages/ForgotPassword/forgotpassword.vue";
import LandingScreen from "../../Inventory/pages/landingScreen/Landing.vue";
import Dashboard from "../../Inventory/pages/Dashboard/dashboard.vue";
import flowchart from "../../../modules/Inventory/pages/Dashboard/Flowchart.vue";
import availabilitycalendar from "../../../modules/Inventory/pages/Dashboard/AvailabilityCalendar.vue";
import Layout from "../../Inventory/components/Layout/Header.vue";
import Masters from "../../Inventory/pages/MastersforInventory/MastersforInventory.vue";
import UnitMasters from "../pages/Masters/Items/UnitMaster/UnitTableview.vue";
// import UnitConversion from "@/";
import UnitConversion from "../../../modules/Inventory/pages/Masters/Items/UnitCoversionMaster/UnitConversionTable.vue";
import ItemConfiguration from "../../../modules/Inventory/pages/Masters/Items/ItemConfiguration/ItemConfigTable.vue";
import StoreMaster from "../pages/Masters/Stores/StoreMaster/StoreTableview.vue";
import RackMaster from "../pages/Masters/Stores/RackMaster/RackTableview.vue";
import BoxMaster from "../pages/Masters/Stores/BoxMaster/BoxTableview.vue";
import PackSizeMaster from "../pages/Masters/Items/PackSizeMaster/PackSizeTableview.vue";
import StockReasons from "../pages/Masters/Items/StockReason/StockReasonTableview.vue";
import Sampleview from "../../../sampleview.vue";
import codeTemplate from "../../../modules/Inventory/pages/codeTemplate/codeTemplate.vue";
//revisequoteform
import ReviseQuoteForm from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/ReviseQuoteForm.vue";
//Details
import StoreTabDetails from "../../../modules/Inventory/pages/Details/StoreTabDetails.vue";
//Master Details
import StoreMasterDetails from "../pages/Masters/Stores/StoreMaster/StoreDetails.vue";
//Master create
import Createstore from "../pages/Masters/Stores/StoreMaster/StoreCreation.vue";

//Items Master
import ItemMasterTableview from "../pages/Masters/Items/ItemMaster/ItemTableview.vue";
import ItemMasterDetails from "../pages/Masters/Items/ItemMaster/ItemDetails.vue";
import ItemMasterCreation from "../pages/Masters/Items/ItemMaster/ItemCreation.vue";

//Surgery brand and model mapping
import SurgertBrandModelMappingTable from "../pages/Masters/Items/SurgeryBrandModel/SurgertBrandModelMappingTable.vue";

//ItemsCategory
import CategoryTableview from "../pages/Masters/ItemCategory/CategoryMaster/CategoryTableview.vue";
import GroupTableview from "../pages/Masters/ItemCategory/GroupMaster/GroupTableview.vue";
import SubgroupTableview from "../pages/Masters/ItemCategory/SubGroupMaster/SubGroupTableview.vue";

//Supppliers
import DeliveryModeTableview from "../pages/Masters/Supplier/DeliveryMode/DeliveryModeTableview.vue";
import DeliveryTermsTableview from "../pages/Masters/Supplier/DeliveryTerms/DeliveryTermsTableview.vue";
import OtherTermsTableview from "../pages/Masters/Supplier/otherTerms/OtherTermsTableview.vue";
import PaymentTermsTableview from "../pages/Masters/Supplier/PaymentTerms/PaymentTermsTableview.vue";
//Supppliers
import SupplierMasterTableview from "../pages/Masters/Supplier/SupplierMaster/SupplierMasterTableview.vue";

import SupplierMasterCreation from "../pages/Masters/Supplier/SupplierMaster/SupplierMasterCreation.vue";
import SupplierMasterDetailsView from "../pages/Masters/Supplier/SupplierMaster/SupplierMasterDetailsView.vue";

//Customer

import CustomerMasterTableview from "../pages/Masters/Supplier/Customer/CustomerMasterTableview.vue";

import CustomerMasterCreation from "../pages/Masters/Supplier/Customer/CustomerMasterCreation.vue";
import CustomerMasterDetailsView from "../pages/Masters/Supplier/Customer/CustomerMasterDetailsView.vue";

//Tax
//TaxMaster
import TaxMasterTableview from "../pages/Masters/Tax/TaxMaster/TaxMasterTableview.vue";
import TaxMasterCreation from "../pages/Masters/Tax/TaxMaster/TaxMasterCreation.vue";

//HSN
import HSNMasterTableview from "../pages/Masters/Tax/HSN/HSNTableview.vue";

//SubTax
import SubTaxMasterTable from "../pages/Masters/Tax/SubTax/SubTaxTable.vue";
import SubTaxCreation from "../pages/Masters/Tax/SubTax/SubTaxCreation.vue";

//Manufacturer
//ManufaturerMaster
import ManufacturerMasterTableview from "../pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerMasterCreation from "../pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterCreation.vue";
import ManufacturerMasterDetails from "../pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterDetails.vue";

//Store
//Room
import RoomTableview from "../pages/Masters/Stores/RoomMaster/RoomTableview.vue";

//Row
import Rowtableview from "../pages/Masters/Stores/RowMaster/RowTableview.vue";

//Pharmacy
//GenericMaster
import GenericMasterTableview from "../pages/Masters/Pharmacy/GenericMaster/GenericMasterTableview.vue";
import GenericMasterFilterview from "../pages/Masters/Pharmacy/GenericMaster/GenericmasterFilter.vue";

//PackageMaster
import PackageMasterCreation from "../../../modules/Inventory/pages/Masters/Package/PackageMasterCreation.vue";
import PackageMasterTableview from "../../../modules/Inventory/pages/Masters/Package/PackageMasterTableview.vue";

//Transaction
//PurchaseOrder
//POCreation
import POCreation from "../../Inventory/pages/Transaction/PurchaseOrder/POCreation.vue";

//POTable
import POTable from "../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
//PODetails
import PODetails from "../../../modules/Inventory/pages/Transaction/PurchaseOrder/PODetails.vue";

//PurchaseIndent
//PurchaseIndentCreation
import PurchaseIndentCreation from "../pages/Transaction/PurchaseIndent/PurchaseIndentCreation.vue";
//StockIn
//StockInCreation
import StockInCreation from "../pages/Transaction/stockin/StockInCreation.vue";
//StockInTableview
import StockInTableview from "../pages/Transaction/stockin/StockInTableview.vue";
//stock out
import StockOut from "../../../modules/Inventory/pages/Transaction/StockOut/StockOut.vue";
//GRNReturn
import GRNReturn from "../../../modules/Inventory/pages/Transaction/StockOut/GRNReturn.vue";
//Consumption
import Consumption from "../../../modules/Inventory/pages/Transaction/StockOut/consumption/Consumption.vue";
//Issue
import Issue from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/Issue.vue";
//PickList
import PickList from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/PickList.vue";
//PickListTableView
import PickListTableView from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/PickListTableView.vue";
//outbound Issue
import OutboundIssueDetails from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/OutBoundIssue/OutBoundIssueDetails.vue";
//Inbound Issue
import InboundIssueDetails from "../../../modules/Inventory/pages/Transaction/stockin/issue/InBoundIssue/InBoundIssueDetails.vue";
//grn
import grn from "../../../modules/Inventory/pages/Transaction/stockin/grn/grn.vue";
//GrnTableDetails
import GrnTableDetails from "../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTableDetails.vue";

//Issue Details
import IssueDetails from "../../../modules/Inventory/pages/Details/Issue/IssueDetails.vue";
//Issue Return Details
import IssueReturnDetails from "../../../modules/Inventory/pages/Details/IssueReturnDetails/IssueReturnDetails.vue";
//Request
import Request from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/Request.vue";
import IndentTemplateCreation from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/IndentTemplateCreation.vue";
import IndentTemplateDetails from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/indentTemplate/IndentTemplateDetails.vue";

//PI
import PI from "../../../modules/Inventory/pages/Transaction/PI.vue";
//PR
import PR from "../../../modules/Inventory/pages/Transaction/PurchaseRequest/purchaseRequestCreation.vue";

import prtopo from "../../../modules/Inventory/pages/Transaction/PurchaseRequest/prtopo.vue";
//Quotes
import Quotes from "../../../modules/Inventory/pages/Transaction/Quotes.vue";
//Quotescompare
import Quotescompare from "../../../modules/Inventory/pages/Transaction/Quotes/QuotesCompare.vue";
//Comparision quotes
import QuotesComparisionPage from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesComparisionPage.vue";
//Add opening stock & Grn Without Po
import AddOpeningStock from "../pages/Transaction/AddOpeningStock.vue";
//Consumption Return
import ConsumptionReturn from "../pages/Transaction/ConsumptionReturn.vue";
//Grn with po
import GrnWithPo from "../pages/Transaction/GrnWithPo.vue";
//RatecontractCreation
import RateContractCreation from "../pages/Transaction/RateContract/RateContractCreation.vue";
//RateContractTableview
import RateContractTableview from "../pages/Transaction/RateContract/RateContractTableview.vue";

//Item category mapping with supplier

import StoreCategoryMappingCreation from "../pages/Masters/ItemCategory/StoreCategoryMapping/StoreCategoryMappingCreation.vue";
import StoreCategoryMappingTblview from "../pages/Masters/ItemCategory/StoreCategoryMapping/StoreCategoryMappingTblview.vue";

import ItemStoreMappingTblview from "../pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import ItemStoreMappingCreation from "../pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingCreation.vue";

import RequestDetails from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestDetails.vue";

import PurchaseIndentDetails from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/purchaseindent/PurchaseIndentDetails.vue";
import InBoundRequestDetails from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/inboundrequest/InboundRequestDetails.vue";

import OutBoundRequestDetails from "../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/outboundrequest/OutboundRequestDetails.vue";
import GrnReturnDetails from "../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnDetails.vue";

//Manufacturer Details
import ManufacturerDetails from "../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ItemSupplierMappingCreation from "../pages/Masters/ItemCategory/ItemSupplierMapping/ItemSupplierMappingCreation.vue";
import ItemSupplierMappingTblview from "../pages/Masters/ItemCategory/ItemSupplierMapping/ItemSupplierMappingTblview.vue";
import GrnDetails from "../../../modules/Inventory/pages/Transaction/stockin/grn/GrnDetails.vue";
import Reports from "../../../modules/Inventory/pages/Reports/Reports.vue";
import purchaseRequestDetails from "../../../modules/Inventory/pages/Transaction/PurchaseRequest/purchaseRequestDetails.vue";
import storeItemMappingTable from "../../../modules/Inventory/pages/Masters/ItemCategory/StoreItemMapping/storeItemMappingTableView.vue";
import storeItemMappingCreation from "../../../modules/Inventory/pages/Masters/ItemCategory/StoreItemMapping/storeItemMappingCreation.vue";
import converttopo from "../../../modules/Inventory/pages/Transaction/PurchaseRequest/ConvertToPo.vue";
import accountHeadTableview from "../pages/Masters/Items/AccountHead/accountHeadTableview.vue";
import accountSubHeadTableview from "../pages/Masters/Items/AccountSubHead/accountSubHeadTableview.vue";
import reOrderLevelBasedPO from "../../../modules/Inventory/pages/Transaction/ReOrderLevel/reOrderLevelBasedPO.vue";
import reOrderToPO from "../../../modules/Inventory/pages/Transaction/ReOrderLevel/reOrderToPO.vue";
import setreOrderLevel from "../../../modules/Inventory/pages/Transaction/ReOrderLevel/setreOrderLevel.vue";
import ItemTrackerView from "../../../modules/Inventory/pages/Transaction/ItemTracker/ItemTracker.vue";

import SupplierPaymentDetails from "../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/SupplierPaymentDetailsView.vue";

import maintenanceScheduleMasterTableview from "../../../modules/Inventory/pages/AssetManagement/Masters/view/MaintenanceScheduleMaster/maintenanceScheduleMasterTableview.vue";
import agreementMasterTableview from "../../../modules/Inventory/pages/AssetManagement/Masters/view/AgreementMaster/agreementMasterTableview.vue";
import assetStatusMasterTableview from "../../../modules/Inventory/pages/AssetManagement/Masters/view/AssetStatusMaster/assetStatusMasterTableview.vue";
import depreciationMethodMasterTableview from "../../../modules/Inventory/pages/AssetManagement/Masters/view/DepreciationMethodMaster/depreciationMethodMasterTableview.vue";
import locationMasterTableview from "../../../modules/Inventory/pages/AssetManagement/Masters/view/LocationMaster/locationMasterTableview.vue";

import agreementMasterCreation from "../../../modules/Inventory/pages/AssetManagement/Masters/view/AgreementMaster/agreementMasterCreation.vue";
import locationMasterCreation from "../../../modules/Inventory/pages/AssetManagement/Masters/view/LocationMaster/locationMasterCreation.vue";

import OpeningStockCreation from "../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/OpeningStock/OpeningStockCreation.vue";
import GrnItemTableview from "../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/MassAssetConversion/GrnItemTableview.vue";
import ItemAssetDetails from "../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/ItemAssetDetails.vue";

import AssignAsset from "../../../modules/Inventory/pages/AssetManagement/Transaction/view/Deployment/AssetAssign.vue";

import AssetTrackingReturnManagement from "../../../modules/Inventory/pages/AssetManagement/Transaction/view/Deployment/AssetTrackingandReturnManagement.vue";

import Test from "../../../modules/Inventory/pages/AssetManagement/Test.vue";
import agreementMasterDetails from "../../../modules/Inventory/pages/AssetManagement/Masters/view/AgreementMaster/agreementMasterDetails.vue";

import ConsigneePO from "../../../modules/Inventory/pages/Transaction/PurchaseOrder/ConsigneePO.vue";
import ConsigneeToPO from "../../../modules/Inventory/pages/Transaction/PurchaseOrder/ConsigneeToPO.vue";
import ItemIssueCreation from "../../../modules/Inventory/pages/Transaction/PatientIssue/ItemIssueCreation.vue";
import POGRNDetail from "../../../modules/Inventory/pages/Transaction/PurchaseOrder/POGRNDetail.vue";
import PaymentDashboard from "../../../modules/Inventory/pages/Dashboard/PaymentDashboard.vue";
import TallyPosting from "../../../modules/Inventory/pages/Transaction/Tally/TallyPosting.vue";
import ScheduleMasterTableView from "../../../modules/Inventory/pages/Masters/Items/ScheduleMaster/ScheduleMasterTableView.vue";
import resetpassword from "../pages/ForgotPassword/resetpassword.vue";
import IssueReturnCreation from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/IssueReturnCreation.vue";

import SalseOrderIssue from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/SalesOrder/SalesOrderIssue.vue";
import SalseOrderDetails from "../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/SalesOrder/SalesOrderDetails.vue";

import ChecklistMasterTableView from "../pages/Masters/Items/Checklist/ChecklistMasterTableView.vue";

export const inventryrouter = [
  {
    path: "/landingScreen",
    name: "landingScreen",
    component: LandingScreen,
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: forgotpassword,
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: resetpassword,
  },
  {
    path: "/ItemTrackerView",
    name: "ItemTrackerView",
    component: ItemTrackerView,
  },
  // {
  //   path: "/Test",
  //   name: "Test",
  //   component: Test,
  // },
  {
    path: "/InventoryLayout",
    name: "InventoryLayout",
    component: Layout,

    children: [
      // Default redirect to Masters when accessing InventoryLayout
      {
        path: "",
        name: "InventoryDefault",
        redirect: "/Masters",
      },
      // {
      //   path: "/dashboard",
      //   name: "dashboard",
      //   component: Dashboard,
      // },

      {
        path: "/flowchart",
        name: "flowchart",
        component: flowchart,
      },
      {
        path: "/availabilitycalendar",
        name: "availabilitycalendar",
        component: availabilitycalendar,
      },
      {
        path: "/POGRNDetail",
        name: "POGRNDetail",
        component: POGRNDetail,
      },
      {
        path: "/InventoryReport",
        name: "Reports",
        component: Reports,
      },
      {
        path: "/Masters",
        name: "Masters",
        component: Masters,
      },
      //Items
      //Items master
      {
        path: "/ItemMasterTableview",
        name: "ItemMasterTableview",
        component: ItemMasterTableview,
      },

      {
        path: "/SurgertBrandModelMappingTable",
        name: "SurgertBrandModelMappingTable",
        component: SurgertBrandModelMappingTable,
      },
      {
        path: "/ItemMasterDetails",
        name: "ItemMasterDetails",
        component: ItemMasterDetails,
      },
      {
        path: "/ItemMasterCreation",
        name: "ItemMasterCreation",
        component: ItemMasterCreation,
      },
      //PackSizeMaster
      {
        path: "/PackSizeMaster",
        name: "PackSizeMaster",
        component: PackSizeMaster,
      },
      {
        path: "/StockReasons",
        name: "StockReasons",
        component: StockReasons,
      },
      {
        path: "/UnitMasters",
        name: "UnitMasters",
        component: UnitMasters,
      },
      {
        path: "/UnitConversion",
        name: "UnitConversion",
        component: UnitConversion,
      },
      {
        path: "/storeItemMappingTable",
        name: "storeItemMappingTable",
        component: storeItemMappingTable,
      },
      {
        path: "/storeItemMappingCreation",
        name: "storeItemMappingCreation",
        component: storeItemMappingCreation,
      },
      {
        path: "/ItemConfiguration",
        name: "ItemConfiguration",
        component: ItemConfiguration,
      },

      //ItemsCategory
      //Category master
      {
        path: "/CategoryTableview",
        name: "CategoryTableview",
        component: CategoryTableview,
      },
      //group master
      {
        path: "/groupTableview",
        name: "groupTableview",
        component: GroupTableview,
      },

      {
        path: "/accountHeadTableview",
        name: "accountHeadTableview",
        component: accountHeadTableview,
      },

      {
        path: "/accountSubHeadTableview",
        name: "accountSubHeadTableview",
        component: accountSubHeadTableview,
      },

      //subgroup master
      {
        path: "/subgroupTableview",
        name: "subgroupTableview",
        component: SubgroupTableview,
      },

      //Supppliers
      //DeliveryMode master
      {
        path: "/DeliveryModeTableview",
        name: "DeliveryModeTableview",
        component: DeliveryModeTableview,
      },

      //DeliveryTerms master
      {
        path: "/DeliveryTermsTableview",
        name: "DeliveryTermsTableview",
        component: DeliveryTermsTableview,
      },

      //OtherTerms master
      {
        path: "/OtherTermsTableview",
        name: "OtherTermsTableview",
        component: OtherTermsTableview,
      },
      //PaymentTerms master
      {
        path: "/PaymentTermsTableview",
        name: "PaymentTermsTableview",
        component: PaymentTermsTableview,
      },
      //Supplier master
      {
        path: "/SupplierMasterTableview",
        name: "SupplierMasterTableview",
        component: SupplierMasterTableview,
      },
      {
        path: "/SupplierMasterDetailsView",
        name: "SupplierMasterDetailsView",
        component: SupplierMasterDetailsView,
      },
      {
        path: "/SupplierMasterCreation",
        name: "SupplierMasterCreation",
        component: SupplierMasterCreation,
      },
      //customer
      {
        path: "/CustomerMasterTableview",
        name: "CustomerMasterTableview",
        component: CustomerMasterTableview,
      },
      {
        path: "/CustomerMasterDetailsView",
        name: "CustomerMasterDetailsView",
        component: CustomerMasterDetailsView,
      },
      {
        path: "/CustomerMasterCreation",
        name: "CustomerMasterCreation",
        component: CustomerMasterCreation,
      },

      //Store
      {
        path: "/Createstore",
        name: "Createstore",
        component: Createstore,
      },
      {
        path: "/StoreMaster",
        name: "StoreMaster",
        component: StoreMaster,
      },
      {
        path: "/RackMaster",
        name: "RackMaster",
        component: RackMaster,
      },
      {
        path: "/BoxMaster",
        name: "BoxMaster",
        component: BoxMaster,
      },

      {
        path: "/StoreMasterDetails",
        name: "StoreMasterDetails",
        component: StoreMasterDetails,
      },
      //Room
      {
        path: "/RoomTableview",
        name: "RoomTableview",
        component: RoomTableview,
      },
      //Row
      {
        path: "/Rowtableview",
        name: "Rowtableview",
        component: Rowtableview,
      },
      {
        path: "/sampleview",
        name: "sampleview",
        component: Sampleview,
      },
      //Tax
      //Tax Master
      {
        path: "/TaxMasterTableview",
        name: "TaxMasterTableview",
        component: TaxMasterTableview,
      },
      {
        path: "/TaxMasterCreation",
        name: "TaxMasterCreation",
        component: TaxMasterCreation,
      },

      //HSN
      {
        path: "/HSNMasterTableview",
        name: "HSNMasterTableview",
        component: HSNMasterTableview,
      },
      //SubTax
      {
        path: "/SubTaxMasterTableview",
        name: "SubTaxMasterTableview",
        component: SubTaxMasterTable,
      },
      {
        path: "/SubTaxMasterCreation",
        name: "SubTaxMasterCreation",
        component: SubTaxCreation,
      },
      //Manufacturer
      //ManufaturerMaster
      {
        path: "/ManufacturerMasterTableview",
        name: "ManufacturerMasterTableview",
        component: ManufacturerMasterTableview,
      },
      {
        path: "/ManufacturerMasterCreation",
        name: "ManufacturerMasterCreation",
        component: ManufacturerMasterCreation,
      },
      {
        path: "/ManufacturerMasterDetails",
        name: "ManufacturerMasterDetails",
        component: ManufacturerMasterDetails,
      },
      //Pharmacy
      //GenericMaster
      {
        path: "/GenericMasterTableview",
        name: "GenericMasterTableview",
        component: GenericMasterTableview,
      },
      {
        path: "/GenericMasterFilterview",
        name: "GenericMasterFilterview",
        component: GenericMasterFilterview,
      },
      //PackageMaster
      {
        path: "/PackageMasterTableview",
        name: "PackageMasterTableview",
        component: PackageMasterTableview,
      },
      {
        path: "/PackageMasterCreation",
        name: "PackageMasterCreation",
        component: PackageMasterCreation,
      },
      //Transaction
      //PurchaseOrder
      //POCreation
      {
        path: "/POCreation",
        name: "POCreation",
        component: POCreation,
      },
      //POTable
      {
        path: "/POTable",
        name: "POTable",
        component: POTable,
      },
      //PODetails
      {
        path: "/PODetails",
        name: "PODetails",
        component: PODetails,
      },
      //PurchaseIndent
      //PurchaseIndentCreation
      {
        path: "/PurchaseIndentCreation",
        name: "PurchaseIndentCreation",
        component: PurchaseIndentCreation,
      },
      //PurchaseIndentDetails
      {
        path: "/PurchaseIndentDetails",
        name: "PurchaseIndentDetails",
        component: PurchaseIndentDetails,
      },
      //ItemRequest
      //ItemRequestCreation
      {
        path: "/StockInCreation",
        name: "StockInCreation",
        component: StockInCreation,
      },

      //stockout
      {
        path: "/stockout",
        name: "stockout",
        component: StockOut,
      },
      {
        path: "/GRNReturn",
        name: "GRNReturn",
        component: GRNReturn,
      },
      {
        path: "/Consumption",
        name: "Consumption",
        component: Consumption,
      },
      {
        path: "/Issue",
        name: "Issue",
        component: Issue,
      },
      //PickList
      {
        path: "/PickList",
        name: "PickList",
        component: PickList,
      },
      //PickListTableView
      {
        path: "/PickListTableView",
        name: "PickListTableView",
        component: PickListTableView,
      },
      //OutboundIssue
      {
        path: "/OutboundIssueDetails",
        name: "OutboundIssueDetails",
        component: OutboundIssueDetails,
      },
      //InboundIssueDetails
      {
        path: "/InboundIssueDetails",
        name: "InboundIssueDetails",
        component: InboundIssueDetails,
      },
      //Issue Details

      {
        path: "/IssueDetails",
        name: "IssueDetails",
        component: IssueDetails,
      },
      //Issue Return Details

      {
        path: "/IssueReturnDetails",
        name: "IssueReturnDetails",
        component: IssueReturnDetails,
      },
      //ItemRequestTableview
      {
        path: "/StockInTableview",
        name: "StockInTableview",
        component: StockInTableview,
      },
      {
        path: "/PI",
        name: "PI",
        component: PI,
      },
      {
        path: "/PR",
        name: "PR",
        component: PR,
      },
      {
        path: "/prtopo",
        name: "prtopo",
        component: prtopo,
      },
      {
        path: "/purchaseRequestDetails",
        name: "purchaseRequestDetails",
        component: purchaseRequestDetails,
      },
      {
        path: "/converttopo",
        name: "converttopo",
        component: converttopo,
      },
      {
        path: "/Quotes",
        name: "Quotes",
        component: Quotes,
      },
      {
        path: "/ReviseQuoteForm",
        name: "ReviseQuoteForm",
        component: ReviseQuoteForm,
      },
      //Comparision Quotes
      {
        path: "/QuotesComparisionPage",
        name: "QuotesComparisionPage",
        component: QuotesComparisionPage,
      },
      {
        path: "/Request",
        name: "Request",
        component: Request,
      },
      {
        path: "/IndentTemplateCreation",
        name: "IndentTemplateCreation",
        component: IndentTemplateCreation,
      },
      {
        path: "/IndentTemplateDetails",
        name: "IndentTemplateDetails",
        component: IndentTemplateDetails,
      },
      {
        path: "/RequestDetails",
        name: "RequestDetails",
        component: RequestDetails,
      },

      //StockIn

      //AddOpeningStockVue
      {
        path: "/OpeningStock",
        name: "OpeningStock",
        component: AddOpeningStock,
      },

      //GrnWithPoVue
      {
        path: "/GrnWithPo",
        name: "GrnWithPo",
        component: GrnWithPo,
      },
      {
        path: "/reOrderLevelBasedPO",
        name: "reOrderLevelBasedPO",
        component: reOrderLevelBasedPO,
      },
      {
        path: "/setreOrderLevel",
        name: "setreOrderLevel",
        component: setreOrderLevel,
      },

      {
        path: "/reOrderToPO",
        name: "reOrderToPO",
        component: reOrderToPO,
      },

      //ConsumptionReturn
      {
        path: "/ConsumptionReturn",
        name: "ConsumptionReturn",
        component: ConsumptionReturn,
      },
      {
        path: "/RateContractCreation",
        name: "RateContractCreation",
        component: RateContractCreation,
      },
      //RateContractTableview
      {
        path: "/RateContractTableview",
        name: "RateContractTableview",
        component: RateContractTableview,
      },
      {
        path: "/ItemStoreMappingTblview",
        name: "ItemStoreMappingTblview",
        component: ItemStoreMappingTblview,
      },
      // item category mapping with store
      {
        path: "/ItemStoreMappingCreation",
        name: "ItemStoreMappingCreation",
        component: ItemStoreMappingCreation,
      },
      {
        path: "/InBoundRequestDetails",
        name: "InBoundRequestDetails",
        component: InBoundRequestDetails,
      },
      {
        path: "/OutBoundRequestDetails",
        name: "OutBoundRequestDetails",
        component: OutBoundRequestDetails,
      },
      {
        path: "/GrnReturnDetails",
        name: "GrnReturnDetails",
        component: GrnReturnDetails,
      },
      //Details
      //StoreTabDetails
      {
        path: "/StoreTabDetails",
        name: "StoreTabDetails",
        component: StoreTabDetails,
      },
      //ManufacturerDetails
      {
        path: "/ManufacturerDetails",
        name: "ManufacturerDetails",
        component: ManufacturerDetails,
      },
      {
        path: "/ItemSupplierMappingCreation",
        name: "ItemSupplierMappingCreation",
        component: ItemSupplierMappingCreation,
      },

      {
        path: "/ItemSupplierMappingTblview",
        name: "ItemSupplierMappingTblview",
        component: ItemSupplierMappingTblview,
      },
      //GrnDetails
      {
        path: "/GrnDetails",
        name: "GrnDetails",
        component: GrnDetails,
      },
      // Quotescompare
      {
        path: "/Quotescompare",
        name: "Quotescompare",
        component: Quotescompare,
      },

      // Store category mapping
      {
        path: "/StoreCategoryMappingCreation",
        name: "StoreCategoryMappingCreation",
        component: StoreCategoryMappingCreation,
      },
      {
        path: "/StoreCategoryMappingTblview",
        name: "StoreCategoryMappingTblview",
        component: StoreCategoryMappingTblview,
      },
      {
        path: "/IcodeTemplate",
        name: "IcodeTemplate",
        component: codeTemplate,
      },
      {
        path: "/grn",
        name: "grn",
        component: grn,
      },
      {
        path: "/GrnTableDetails",
        name: "GrnTableDetails",
        component: GrnTableDetails,
      },
      {
        path: "/SupplierPaymentDetails",
        name: "SupplierPaymentDetails",
        component: SupplierPaymentDetails,
      },
      //AssetManagement

      {
        path: "/maintenanceScheduleMasterTableview",
        name: "maintenanceScheduleMasterTableview",
        component: maintenanceScheduleMasterTableview,
      },
      {
        path: "/agreementMasterTableview",
        name: "agreementMasterTableview",
        component: agreementMasterTableview,
      },
      {
        path: "/agreementMasterCreation",
        name: "agreementMasterCreation",
        component: agreementMasterCreation,
      },
      {
        path: "/assetStatusMasterTableview",
        name: "assetStatusMasterTableview",
        component: assetStatusMasterTableview,
      },
      {
        path: "/depreciationMethodMasterTableview",
        name: "depreciationMethodMasterTableview",
        component: depreciationMethodMasterTableview,
      },
      {
        path: "/locationMasterTableview",
        name: "locationMasterTableview",
        component: locationMasterTableview,
      },
      {
        path: "/locationMasterCreation",
        name: "locationMasterCreation",
        component: locationMasterCreation,
      },

      {
        path: "/OpeningStockCreation",
        name: "OpeningStockCreation",
        component: OpeningStockCreation,
      },

      {
        path: "/GrnItemTableview",
        name: "GrnItemTableview",
        component: GrnItemTableview,
      },
      {
        path: "/AssignAsset",
        name: "AssignAsset",
        component: AssignAsset,
      },
      {
        path: "/AssetTrackingReturnManagement",
        name: "AssetTrackingReturnManagement",
        component: AssetTrackingReturnManagement,
      },
      {
        path: "/ItemAssetDetails",
        name: "ItemAssetDetails",
        component: ItemAssetDetails,
      },
      {
        path: "/agreementMasterDetails",
        name: "agreementMasterDetails",
        component: agreementMasterDetails,
      },
      {
        path: "/ConsigneePO",
        name: "ConsigneePO",
        component: ConsigneePO,
      },

      {
        path: "/ConsigneeToPO",
        name: "ConsigneeToPO",
        component: ConsigneeToPO,
      },
      {
        path: "/ItemIssueCreation",
        name: "ItemIssueCreation",
        component: ItemIssueCreation,
      },
      {
        path: "/PaymentDashboard",
        name: "PaymentDashboard",
        component: PaymentDashboard,
      },
      {
        path: "/ScheduleMasterTableView",
        name: "ScheduleMasterTableView",
        component: ScheduleMasterTableView,
      },
      {
        path: "/ChecklistMasterTableView",
        name: "ChecklistMasterTableView",
        component: ChecklistMasterTableView,
      },
      {
        path: "/IssueReturnCreation",
        name: "IssueReturnCreation",
        component: IssueReturnCreation,
      },
      {
        path: "/SalseOrderIssue",
        name: "SalseOrderIssue",
        component: SalseOrderIssue,
      },
      {
        path: "/SalseOrderDetails",
        name: "SalseOrderDetails",
        component: SalseOrderDetails,
      },

      // {
      //   path: "/TallyPosting",
      //   name: "TallyPosting",
      //   component: TallyPosting,
      // },
    ],
  },
];
